<template>
  <div
    class="b2b-details-box"
    :class="open_accor == true ? 'mobile-sidebar-card' : ''"
  >
    <div class="b2b-details-box-header" @click="developpBlock">
      <div class="d-flex justify-content-between">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap"
        >
          <h2 class="font-bold mb-0">Mini relevé de compte</h2>
        </div>
        <div
          v-if="open_accor == true"
          @click="developpBlock"
          class="
            chevron-parent
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <i
            @click="developpBlock"
            class="mdi mdi-chevron-right"
            style="font-size: 24px !important"
          ></i>
        </div>
        <div
          v-if="open_accor == false && checkScreen === 'mobile'"
          @click="developpBlock"
          class="
            chevron-parent
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <i
            @click="developpBlock"
            class="mdi mdi-chevron-down"
            style="font-size: 24px !important"
          ></i>
        </div>
      </div>
    </div>
    <div class="" v-show="open_accor == false">
      <Skeleton
        :number="5"
        size="36px"
        spacing_bottom="mb-3"
        v-if="loader == true"
      />
      <div v-else>
        <EmptyState
          :message="'Aucune relevé disponible'"
          v-if="releves.length == 0"
        />
        <div class="pt-3" v-else>
          <!-- <div class="d-flex justify-content-end mb-2">
            <button
              class="btn btn-primary"
              :disabled="download_processing"
              @click="downloadPDF()"
            >
              <b-spinner v-if="download_processing == true"></b-spinner>
              <span v-if="download_processing == false">Télécharger</span>
            </button>
          </div> -->
          <b-table
            striped
            :stacked="checkScreen == 'mobile'"
            responsive
            :fields="fields"
            :items="releves"
          >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from "@/components/business/skeleton";
import EmptyState from "@/components/business/emptyState";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { subscriber } from "@/services/";
import _ from "lodash";
export default {
  name: "mtn-business",
  components: {
    Skeleton,
    EmptyState,
  },
  data: function () {
    return {
      loader: true,
      releves: [],
      fields: [
        {
          key: "transaction_number",
          label: "N° transaction",
        },
        {
          key: "type",
          label: "Type",
        },
        {
          key: "date",
          label: "Date",
        },
        {
          key: "debit",
          label: "Débit",
        },
        {
          key: "credit",
          label: "Crédit",
        },
        {
          key: "balance",
          label: "Balance",
        },
      ],
      open_accor: false,
      download_processing: false,
    };
  },
  created: async function () {
    this.loadMiniStatement();
    if (this.checkScreen === "mobile") {
      this.open_accor = true;
    }
  },
  computed: {
    checkScreen() {
      if (window.screen.availWidth >= 625) {
        return "laptop";
      } else {
        return "mobile";
      }
    },
  },
  methods: {
    async downloadPDF() {
      if (this.download_processing == true) {
        return;
      } else {
        this.download_processing = true;
        await subscriber.getMinistatementPdf().then((response) => {
          this.download_processing = false;
          if (response.success == true) {
            if (!_.isNil(response.filename)) {
              const link = document.createElement("a");
              link.href = `https://my.mtn.bj/aws/${response.filename}`;
              link.target = "_blank";
              link.setAttribute("download", `Mini relevé de compte.pdf`);
              link.click();
            }
          }
        });
      }
    },
    developpBlock() {
      if (this.checkScreen == "mobile") {
        this.open_accor = !this.open_accor;
      }
    },
    async loadMiniStatement() {
      if (this.$store.state.core.business_account.account_number !== null) {
        await subscriber.get_mini_statement().then((response) => {
          this.loader = false;
          if (_.isUndefined(response.error)) {
            if (!_.isNil(response.api_output)) {
              if (!_.isNil(response.api_output.acc_invoice_dtls_statment)) {
                if (
                  !_.isNil(
                    response.api_output.acc_invoice_dtls_statment
                      .invoice_dtls_statment
                  )
                ) {
                  this.releves =
                    response.api_output.acc_invoice_dtls_statment.invoice_dtls_statment;
                  this.releves = this.releves.map((element) => {
                    return {
                      transaction_number: element.value[0],
                      type: element.value[5],
                      date: element.value[1],
                      debit: element.value[2] + " FCFA",
                      credit: element.value[3] + " FCFA",
                      balance: element.value[4] + " FCFA",
                    };
                  });
                }
              }
            }
          } else {
            return;
          }
        });
      } else {
        this.loader = false;
      }
    },
  },
  watch: {
    "$store.state.core.business_account.account_number"() {
      this.loadMiniStatement();
    },
  },
};
</script>
<style scoped lang="css">
::v-deep .table {
  font-size: 14px !important;
}
::v-deep .table thead th {
  font-weight: 400 !important;
  text-align: left !important;
}
::v-deep td {
  text-align: left !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td {
  position: relative;
  height: 50px !important;
  border-bottom: none !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td .form-check.p-0 {
  position: absolute;
  right: 0.75rem !important;
  top: 0.75rem;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td:last-child {
  padding-bottom: 0.75rem !important;
  border-bottom: none !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > :first-child {
  border-top-width: 1px !important;
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td::before {
  /* text-align: left !important; */
  text-align: right !important;
  /* width: auto !important; */
}
::v-deep .table.b-table.b-table-stacked > tbody > tr > td > div {
  width: auto !important;
  padding-left: 0 !important;
}
::v-deep .spinner-border {
  width: 20px !important;
  height: 20px !important;
}
</style>

